/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input.form-control[_ngcontent-%COMP%]{border:1px solid #a8aaa7;border-radius:4px;color:#444;font-weight:600;font-size:13px;line-height:20px}"];
export { styles as styles };
